/* eslint-disable no-undef */
export const env = { ...process.env, ...window['env'] }